import { createVNode as s, mergeProps as n } from "vue";
import m from "../node_modules/@pf-ui/pf-icon-svg/es/asn/MsgTwoTone.js";
import a from "../components/PfIcon.js";
const o = (r, e) => {
  const t = {
    ...r,
    ...e.attrs
  };
  return s(a, n(t, {
    icon: m
  }), null);
};
o.displayName = "MsgTwoTone";
o.inheritAttrs = !1;
export {
  o as default
};
